// Routage par le fragment d'URL (#/catalogue, #/pratique/identifiant, #/reglages, #/aide).
// Aucune dépendance : suffisant pour une application statique.

import { useEffect, useState } from 'react';

export interface Route {
  segments: string[];
}

function parse(): Route {
  const hash = typeof window === 'undefined' ? '' : window.location.hash;
  const path = hash.replace(/^#\/?/, '');
  const segments = path
    .split('/')
    .map((s) => decodeURIComponent(s))
    .filter(Boolean);
  return { segments };
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(parse);
  useEffect(() => {
    const onChange = () => setRoute(parse());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  return route;
}

export function href(...segments: string[]): string {
  return '#/' + segments.map((s) => encodeURIComponent(s)).join('/');
}

export function navigate(...segments: string[]): void {
  window.location.hash = href(...segments);
}
